import React, { useEffect, useRef, useState } from "react";
import { Menu, Dropdown, Modal, Popover, Tooltip, Form, Radio } from 'antd';
import styles from "./scss/contactlist.module.scss";
import { chats, chatwindowDetails, initialStateModel, LoginState, recentChatSocketReducerStateModel, recentContact, typingReducerModel } from "../../../models/model";
import { URButton } from "../../../shared/widgets/button";
import { ChatService } from "../../../base/chatService";
import { Cookie, getRecentDateFormat, LeftSavedChatClear, mp3Formats, strickerFormat, videoFormat } from "../../../base/utils";
import { useSelector } from "react-redux";
import store from "../../../context/store/store";
import noResult from "../../../styles/images/empty_states/empty-nofound.svg";
import { URChatLeftSkeleton } from "../../../shared/widgets/skeletonLoading/chatLeftSkeleton";
//import { ChatService } from "../../../base/ChatService";
//import { toastInformation } from "../../../base/callService/common";
import { useHistory } from "react-router";
import _ from "lodash";
import moment from "moment";
import { HighlightInner } from "../../contacts/rightsidebar/highlight";
import ProfileAvatarGroup from "./profileavatargroup";
import { SocketChatService } from "../../../base/socketChatService";
import { updateSettingStatus } from "../../../base/socketChatService/newChat";
//import { initiateCall } from "../../../base/callService/callService";
//import { callMainWindowState } from "../../../models/callModel";
import NoContent from "../../../shared/widgets/noContent";
import Lottie from "lottie-react";
import groovyWalkAnimation from "../../../styles/images/typingstatusloading.json";
import { allChatNotification, handleMute, teamfinalString } from "../../../base/socketChatService/utils";
import { Types } from "../../../context/action/action";
import { getChatSummary, toastInformation } from "../../../base/callService/common";
import { initiateCall } from "../../../base/callService/callService";
import { URAvatarGroup } from "../../../shared/widgets/avatarGroup";

type ContactListProps = {
  contactList: Array<recentContact>;
  searchContactList: Array<recentContact>;
  isSearch: boolean;
  isLoader: boolean;
  searchText: string;
  chats?: string;
  updateChatIndex: any;
  pinnedList?: any;
}
type popoverState = {
  isArchive: boolean;
  isDelete: boolean;
  archiveChat: any;
  deleteData: any;
  deleteChat: any;
  isVisible: boolean;
  radioMute: any;
  isMuteModel: boolean;
  isDeactivate: boolean;
  deactivateData: any;

}

function ContactLists({ contactList, searchContactList, isSearch, isLoader, searchText, chats, updateChatIndex, pinnedList }: ContactListProps) {
  const { recentChatList, recentLoading }: recentChatSocketReducerStateModel =
    useSelector((state: initialStateModel) => state.chatSocketRecentReducerState);
  const chatWindow: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  //const {aciveDevicesList}: deviceListModel = useSelector((state: initialStateModel) => state.deviceListReducer);
  const recentChatArray = Object.values(recentChatList);
  const chat_reducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  let { userdetails }: any = useSelector((state: initialStateModel) => state.loginReducer);
  let {chatSummary}:any=store.getState().chatReducer;
  let allContacs: any = store.getState().contactReducer;
  let workContact = allContacs?.workContactsnew;
  let teamContact = allContacs?.teamContacsnew;
  let deleteContact = allContacs?.deleteContacts;
  let { planBased } = store.getState().meetingReducer;

  const [ArchiveModal, setArchiveModal] = useState<popoverState>({ isArchive: false, isDelete: false, archiveChat: {}, deleteData: {}, deleteChat: {}, isVisible: false, radioMute: "Always", isMuteModel: false, isDeactivate: false, deactivateData: {} })
  const [isHoverActiveUser, setisHoverActiveUser] = useState<any>("");
  const toastUndo: any = useSelector((state: any) => state.toastReducer);
  const [mount, setMount] = useState<boolean>(false);
  const [closeAi, setCloseAi] = useState<boolean>(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const [storeAiContactDetails, setStoreAiContactDetails] = useState<any>({});
  //const [hovervisible, setHoverVisible] = useState(false);
  // const { callPermissionDetail}: callMainWindowState = useSelector((state: callMainWindowState) => state);
  // let { flipDeviceInfo } = callPermissionDetail || [];
  let socketTimeout = useRef<any>(null);
  const { typingList }: typingReducerModel = useSelector((state: initialStateModel) => state.typingReducerState);
  const { chatBellNotification }: any = useSelector((state: initialStateModel) => state.bellNotification);
  //const chatSocket = new SocketChatService(userInfo().fromID, userInfo().domainId);
  const history = useHistory();
  let socketService = useRef<any>(null);
  useEffect(() => {
    if (!mount) {
      const userInfo: any = Cookie.get();
      const userInfosess: any = sessionStorage.getItem("userinfo");
      if (userInfosess) {
        const cookieData = JSON.parse(userInfosess);
        socketService.current = new SocketChatService(cookieData.sip_login_id, cookieData.domain_id);
        setMount(true);

      }
    }

  }, [searchContactList, allContacs, recentLoading, recentChatArray,JSON.stringify(chatSummary)]);

  const handleArchiveCancel = () => {
    setArchiveModal({ ...ArchiveModal, isArchive: false, archiveChat: {} });
  };
  useEffect(() => {
    if (toastUndo.undo && socketTimeout.current && toastUndo.key) {
      const timeout = socketTimeout.current;
      updateSettingStatus(timeout.type, timeout.chatId, timeout.settings);
      socketTimeout.current = null;
      socketService.current.toggleUndo(false);
    }
  }, [toastUndo]);

  useEffect(() => {

    let teamsCallNumber: any = localStorage.getItem('call_number');

    if (teamsCallNumber) {
      setTimeout(() => {
        initiateCall(teamsCallNumber, 'audio');
      }, 8000);
    }
  }, [])

  // const recentChatClick =(contact:any)=>{

  //   setisActiveUser(contact.receiver);

  //   let c_details = getcontactDetail(contact.receiver);
  //   c_details.isMySpace = false;

  //   c_details.timeStamp = contact.timeStamp;

  //   ChatService.openChatWindow(c_details);
  //   ChatService.editDraft(false);
  // };

  const closeAiModal=(e:any)=>{
    setCloseAi(false);
  }

useEffect(() => {
  // {Unread Chat Summary}
  const unreadChatFeature = planBased.find((item:any) => item.featureid === 479);
  if (unreadChatFeature && unreadChatFeature.value1 === "Yes") {
    setIsButtonDisabled(true); 
  } else {
    setIsButtonDisabled(false); 
  }
}, [planBased]); 

  const selectMoreOption = (val: any, contact?: any) => {
    // const originalArchive = defaultContacts.searchArchive;
    // const tempArchive = [...defaultContacts.searchArchive];
    // const index = originalArchive.findIndex((value:any)=>value.chatId === data.chatId);
    // originalArchive.splice(index,1);
    // setdefaultContacts({...defaultContacts,  searchArchive:originalArchive,
    //   isSearch:true,searchText:''}); 

    // socketTimeout.current = tempArchive;
    // socketService.current.toastUndo("Chat Unarchived",timer);
    // console.log(isHoverActiveUser,"isHoverActiveUser");
    let hoverdiv: HTMLElement | any = document.getElementById("frezsec") || null;
    var element: HTMLElement | any = document.getElementById("recentchatSec") || null;
    setisHoverActiveUser("")
    console.log(isHoverActiveUser)
    if (hoverdiv) hoverdiv.style["display"] = "none";

    if (element != null) {
      if (element.hasAttribute('scroll') === true) {
        element.removeAttribute("scroll");
        element.removeAttribute("style");
        element.style["overflow-y"] = "overlay";

      }
    }

    let contactObject: any = store.getState().contactReducer;
    let workContact = contactObject?.workContactsnew;
    let teamContact = contactObject?.teamContacsnew;
    let toContact = contact?.type === 1 ? workContact[contact?.to] : teamContact[contact?.chatId];

    socketTimeout.current = contact;
    if (val.key === "pinChat") {
      if (pinnedList?.pinnedContacts?.length < 5) {
        if (!contact?.settings?.isPinned ||
          contact?.settings?.isPinned["s" + userdetails?.sip_login_id] === 0) {
          let chatDetails = {
            chatId: contact?.chatId,
            settingsKey: "isPinned",
            status: 1
          }
          const timer = setTimeout(() => { socketService?.current?.updateRecentChatSettings(chatDetails); socketService?.current?.toastUndo("", "") }, 3000);
          socketService?.current?.toastUndo("Sucess! Chat pinned ", timer, 'pinChat');


        }
      } else {
        toastInformation("Already 5 memeber Pinned Chat", "failure");
      }

    } else if (val.key === "unpinChat"
      && contact?.settings?.isPinned["s" + userdetails?.sip_login_id]) {
      let chatDetails = {
        chatId: contact?.chatId,
        settingsKey: "isPinned",
        status: 0
      }
      const timer = setTimeout(() => { socketService?.current?.updateRecentChatSettings(chatDetails); socketService?.current?.toastUndo("", "") }, 3000);
      socketService?.current?.toastUndo("Removed from Pinned chats", timer, 'unpinChat');
    }

    if (val.key === "deleteChat") {
      setArchiveModal({ ...ArchiveModal, isDelete: true, deleteData: toContact, deleteChat: contact })
    }
    if (val.key === "muteChat") {
      let tooContact = contact?.type === 1 ? workContact[contact?.to] : teamContact['con' + contact?.chatId];
      setArchiveModal({ ...ArchiveModal, isMuteModel: true, deleteData: tooContact, deleteChat: contact })
    } else if (val.key === "unMuteChat") {
      const timestamp = moment().add(24, 'hours').valueOf();
      let chatDetails = {
        chatId: contact?.chatId,
        settingsKey: "isMuted",
        status: 0,
        muteTimestamp: timestamp,
        toSipId: contact?.to,
        type: contact?.type,
        phoneNumber: toContact?.ext
      };
      const timer = setTimeout(() => { socketService?.current?.updateRecentChatSettings(chatDetails); socketService?.current?.toastUndo("", "") }, 3000);
      socketService?.current?.toastUndo("UnMuted Successfully", timer, 'unMuteChat');
    }
   if (val?.key === "markRead") {
      const timer = setTimeout(() => {
        socketService?.current?.markAsRead(contact);
        let chatDetails = {
          chatId: contact?.chatId,
          settingsKey: "markRead",
          status: 1
        };
        socketService?.current?.toastUndo("", "");
        if (!contact?.settings?.markRead) {
          contact.settings.markRead = {};
          contact.settings.markRead["s" + userdetails?.sip_login_id] = 1;
        }
        else if (contact?.settings?.markRead?.["s" + userdetails?.sip_login_id] === 0) {
          contact.settings.markRead["s" + userdetails?.sip_login_id] = 1;
        }
        socketService?.current?.updateRecentChatSettings(chatDetails)
        updateSettingStatus(contact?.type, contact?.type === 1 ? contact?.to : contact?.chatId, contact?.settings);
      }, 3000);
      socketService.current.toastUndo("Conversation marked as read", timer, 'markRead');
    } else if (val.key === "markUnRead") {
      const timer = setTimeout(() => {
        socketService.current.toastUndo("", "");
        let chatDetails = {
          chatId: contact?.chatId,
          settingsKey: "markRead",
          status: 2
        };
        if (!contact?.settings?.markRead) {
          contact.settings.markRead = {};
          // contact.settings.markRead["s" + userdetails?.sip_login_id] = 0;
          // updateSettingStatus(contact.type, contact.type === 1 ? contact?.to : contact?.chatId, contact?.settings);

        }
        if (contact?.settings?.markRead?.["s" + userdetails?.sip_login_id] === 1) {
          contact.settings.markRead["s" + userdetails?.sip_login_id] = 2;
          // updateSettingStatus(contact.type, contact.type === 1 ? contact?.to : contact?.chatId, contact?.settings);
          // socketService?.current?.updateRecentChatSettings(chatDetails)
        }
        socketService?.current?.updateRecentChatSettings(chatDetails)
        updateSettingStatus(contact.type, contact.type === 1 ? contact?.to : contact?.chatId, contact?.settings);
      }, 3000);
      socketService?.current?.toastUndo("Conversation marked as unRead", timer, 'markUnRead');

    }
    if (val.key === "favourite") {
      const favouriteUser = workContact[contact.to];
      const favouriteTUser = teamContact["con" + contact.chatId];
      if (favouriteUser || favouriteTUser) {
        let chatDetails = {
          chatId: favouriteUser?.sip_login_id ? contact?.chatId?.toString() : favouriteTUser?.team_id?.toString(),
          toSipId: favouriteUser?.sip_login_id ? favouriteUser?.sip_login_id?.toString() : favouriteTUser?.team_id?.toString(),
          type: favouriteUser?.sip_login_id ? 1 : 2,
          settingsKey: "isFavourite",
          status: 1,
          phoneNumber: toContact?.ext
        };
        const timer = setTimeout(() => { socketService?.current?.updateRecentChatSettings(chatDetails); socketService?.current?.toastUndo("", "") }, 3000);
        socketService.current.toastUndo("Added to favourites", timer, 'favourite');
      }

    } else if (val.key === "unfavourite") {
      const favouriteUser = workContact[contact?.to];
      const favouriteTUser = teamContact["con" + contact?.chatId];
      if (favouriteUser || favouriteTUser) {
        let chatDetails = {
          chatId: favouriteUser?.sip_login_id ? contact?.chatId?.toString() : favouriteTUser?.team_id?.toString(),
          toSipId: favouriteUser?.sip_login_id ? favouriteUser?.sip_login_id?.toString() : favouriteTUser?.team_id?.toString(),
          settingsKey: "isFavourite",
          type: favouriteUser?.sip_login_id ? 1 : 2,
          status: 0,
          phoneNumber: toContact?.ext ? toContact?.ext : ''
        };
        const timer = setTimeout(() => { socketService?.current?.updateRecentChatSettings(chatDetails); socketService.current.toastUndo("", "") }, 3000);
        socketService.current.toastUndo("Removed from Favourites", timer, 'unfavourite');
      }
    } else if (val.key === 'deactivateContact') {
      setArchiveModal({ ...ArchiveModal, isDeactivate: true, deactivateData: toContact });

    }
    if (val.key === "isArchive") {
      setArchiveModal({ ...ArchiveModal, isArchive: true, archiveChat: contact });
    } else if (val.key === "unarchive") {
      let chatDetails = {
        chatId: contact?.chatId,
        settingsKey: "isArchive",
        status: 0
      }
      socketService?.current?.updateRecentChatSettings(chatDetails);
    }

  }

  var len = Array.isArray(searchContactList) && searchContactList?.length > 7 ? Math.ceil((searchContactList?.length / 8)) : 1;
  var random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();
  const loginDetails: LoginState = useSelector((state: initialStateModel) => state.loginReducer);

  const OpenChatWindow = (contactsDetail: any, contact: any, index?: any, chats?: string) => {
    store.dispatch({
      type:Types.STORE_COMPOSED_MSG,
      payload:{
        composedMsg:{}
      }
    })
    store.dispatch({
      type: Types.COUNT_VALUE,
      payload: {
          countValue: 0
      }
  })
  store.dispatch({
    
    type:Types.SET_ARR_BUFFER,
    payload:{
      aiSessionId:"",
      arrayBuffer:[],
      intent:"",
      aiAssistMessage: ""
    }
  })


    const userDetails = loginDetails.userdetails;
    const socketservice = new SocketChatService(userDetails?.sip_login_id, userDetails?.domain_id);
    let test = {
      chat_id: contact?.chatId,
      from_sip_id: userDetails?.sip_login_id,
      to_sip: contactsDetail?.sip_login_id,
      domain_id: userDetails?.domain_id,
      badge_count: contact?.unreadCount
    }
    socketService?.current?.alldeveiceBadgeCount(test);
    //console.log(contact,"contact")
    if (contactsDetail?.sip_login_id) {
      // let chatDetail ={chatId:generateChatID(userDetails.sip_login_id.toString(), contact.sip_login_id.toString())};
      socketservice.openChatWindow(contactsDetail, history, contact, 'contactpage');
    } else {
      let particularIndex: any = allContacs && allContacs?.allContacs?.findIndex((elem: any) => (elem.team_id === contactsDetail?.team_id));
      if (particularIndex !== -1) {
        contactsDetail = allContacs?.allContacs[particularIndex];
      }

      socketservice.openChatWindow(contactsDetail, history, '', 'contactpage');
    }

    if (contact) {
      socketService?.current?.markAsRead(contact);
  
      let chatDetails = {
        chatId: contact?.chatId,
        settingsKey: "markRead",
        status: 1
      };
  
      if (!contact?.settings?.markRead) {
        contact.settings.markRead = {};
        contact.settings.markRead["s" + userDetails?.sip_login_id] = 1;
      } else if (contact?.settings?.markRead?.["s" + userDetails?.sip_login_id] === 0) {
        contact.settings.markRead["s" + userDetails?.sip_login_id] = 1;
      }
  
      socketService?.current?.updateRecentChatSettings(chatDetails);
      updateSettingStatus(contact?.type, contact?.type === 1 ? contact?.to : contact?.chatId, contact?.settings);
    }
    socketService?.current?.markAsRead(contact);
    let _chatBellNotification = chatBellNotification;
    for (let i = 0; i < _chatBellNotification.length; i++) {
      if (_chatBellNotification[i]?.lastmsgIndex === contact?.lastmsgIndex) {
        _chatBellNotification.splice(i, 1);
      }
    }
    allChatNotification(_chatBellNotification);
    //setisActiveUser(contactsDetail);
    ChatService.editDraft(false);
    ChatService.saveChatHighlight(false, {});
    ChatService.filesHighlight(false, {});
    ChatService.onChangeReplyWindow(false, {});
    chat_reducer.editMessageDetails.isEditing && ChatService.onChangeEditWindow(false, {});
    chat_reducer.isWindowSlide && ChatService.rightSideToogle();
    if (chat_reducer.isDelete) { ChatService.onChangeDeleteWindow(false, ''); }
    if (chat_reducer.isForward) { ChatService.onChangeForwardWindow(false, ''); }
    if (chat_reducer.multiOption) { ChatService.onMultiOptionWindow(false); ChatService.onChangeForwardWindow(false, ''); ChatService.onChangeDeleteWindow(false, ''); }
    if (index > -1) {
      updateChatIndex(index, chats);
      store.dispatch({
        type: Types.TAB_CONTENT_DETAILS,
        payloads: {
          tabcontactDetail: contactsDetail,
          tabcontact: contact,
          tabrecentindex: index

        }
      });

      store.dispatch({
        type: Types.DROPDOWN_NEWCHAT,
        payload: {
          dropdownNewChat: true
        }
      });
    }

  };
  const handleCancel = () => {
    setArchiveModal({ ...ArchiveModal, isDelete: false, deleteData: {}, deleteChat: {} })
  }

  const archiveAction = () => {
    let chatDetails = {
      chatId: ArchiveModal.archiveChat.chatId,
      settingsKey: "isArchive",
      status: 1
    }
    const timer = setTimeout(() => { socketService?.current?.updateRecentChatSettings(chatDetails); socketService.current.toastUndo("", "") }, 3000);
    socketService?.current?.toastUndo("You`ve archived the Chat ", timer);
    setArchiveModal({ ...ArchiveModal, isArchive: false, archiveChat: {} })
  };
  const deleteAction = () => {
    let { landingPage }: LoginState = store.getState().loginReducer;
    let chatDetails = {
      chatId: ArchiveModal?.deleteChat?.chatId,
      settingsKey: "isDeleted",
      status: 1
    }
    let chatIndex = _.findIndex(searchContactList, function (o: any) { return o.chatId === ArchiveModal?.deleteChat?.chatId });
    let contactIndex: any = searchContactList[chatIndex + 1] !== undefined ? searchContactList[chatIndex + 1] : searchContactList[0];
    let particularIndex: any = "";
    if (contactIndex?.type === 1) {
      particularIndex = allContacs && allContacs?.allContacs?.findIndex((elem: any) => (elem?.sip_login_id === parseInt(contactIndex?.to)));
    } else {
      particularIndex = allContacs && allContacs?.allContacs?.findIndex((elem: any) => (elem?.team_id === parseInt(contactIndex?.to)));
    }
    // let deletegroupLandingpage=localStorage.getItem("deletegroupLandingpage");
    // if(deletegroupLandingpage!=='landingopen'){
    //   store.dispatch({
    //     type: Types.LANDING_PAGE,
    //     payload: {
    //       landingPage: true
    //     }
    //   });
    //   localStorage.setItem("deletegroupLandingpage",'landingopen');
    // }
    socketService?.current?.updateRecentChatSettings(chatDetails, 3);
    LeftSavedChatClear();
    socketService?.current?.markAsRead(ArchiveModal?.deleteChat);
    // OpenChatWindow(allContacs?.allContacs[particularIndex],contactIndex,"");
    setArchiveModal({ ...ArchiveModal, isDelete: false, deleteData: {}, deleteChat: {} })
  };

  const openChatMore = (e: any, contact: any) => {
    var element: HTMLElement | any = document.getElementById("recentchatSec") || null;
    if (e === true) {
      setisHoverActiveUser(contact?.to)
    } else {
      setisHoverActiveUser("");
    }
    if (element != null) {

      if (element.hasAttribute('scroll') === true) {
        element.removeAttribute("scroll");
        element.removeAttribute("style");
        element.style["overflow-y"] = "overlay";

        let hoverdiv: HTMLElement | any = document.getElementById("frezsec") || null;

        if (hoverdiv) hoverdiv.style["display"] = "none";
      }
      else {
        element.setAttribute("scroll", "no");
        element.style["overflow"] = "hidden";
        let hoverdiv: HTMLElement | any = document.getElementById("frezsec") || null;

        if (hoverdiv) hoverdiv.style["display"] = "block";
      }
    };
    setArchiveModal({ ...ArchiveModal, isVisible: e })
  };

  // const makeAudioCall = (data: any) => {
  //   if (data) {
  //     if (data.ext) { initiateCall(data.ext, 'audio'); }
  //     else {
  //       toastInformation("Future Implementation");
  //     }
  //   }

  //   else { toastInformation("Please check the number", "failure"); }
  // };
  // const makevideoCall = (data: any) => {

  //   if (data.ext || data.team_id) {
  //     //initiateCall(data.ext,'video'); 
  //     toastInformation("Future Implementation");
  //   }
  //   else { toastInformation("Please check the number", "failure"); }
  // };


  const handleOk = () => {
    let dataRes: any = {
      key: ArchiveModal.radioMute
    }
    handleMute(dataRes, ArchiveModal.deleteData);
    const timer = setTimeout(() => { socketService.current.toastUndo("", "") }, 3000);
    socketService?.current?.toastUndo("Chat muted. All is quiet", timer, 'muteChat');
    setArchiveModal({ ...ArchiveModal, isMuteModel: false, deleteData: {}, deleteChat: {}, radioMute: "Always" })
  };
  const handleCancelMute = () => {
    setArchiveModal({ ...ArchiveModal, isMuteModel: false, deleteData: {}, deleteChat: {}, radioMute: "Always" })
  };
  const radioChecked = (e: any) => {
    setArchiveModal({ ...ArchiveModal, radioMute: e.target.value });
  };
  const deactivateAction = () => {
    ChatService.getDeactivateContact(ArchiveModal?.deactivateData, 0);
    setArchiveModal({ ...ArchiveModal, isDeactivate: false, deactivateData: {} });
  }
  const handleDeactiveCancel = () => {
    setArchiveModal({ ...ArchiveModal, isDeactivate: false, deactivateData: {} });
  }
  const aiOptions=(type:any)=>{
      if(type === "markread"){
        const timer = setTimeout(() => {
          socketService?.current?.markAsRead(storeAiContactDetails.contact);
          let chatDetails = {
            chatId: storeAiContactDetails.contact?.chatId,
            settingsKey: "markRead",
            status: 1
          };
          socketService?.current?.toastUndo("", "");
          if (!storeAiContactDetails.contact?.settings?.markRead) {
            storeAiContactDetails.contact.settings.markRead = {};
            storeAiContactDetails.contact.settings.markRead["s" + userdetails?.sip_login_id] = 1;
          }
          else if (storeAiContactDetails.contact?.settings?.markRead?.["s" + userdetails?.sip_login_id] === 0) {
            storeAiContactDetails.contact.settings.markRead["s" + userdetails?.sip_login_id] = 1;
          }
          socketService?.current?.updateRecentChatSettings(chatDetails)
          updateSettingStatus(storeAiContactDetails.contact?.type, storeAiContactDetails.contact?.type === 1 ? storeAiContactDetails.contact?.to : storeAiContactDetails.contact?.chatId, storeAiContactDetails.contact?.settings);
        }, 3000);
        socketService.current.toastUndo("Conversation marked as read", timer, 'markRead');
      }else{
        OpenChatWindow(storeAiContactDetails.contactsDetail,storeAiContactDetails.contact,storeAiContactDetails.index, storeAiContactDetails.chats)
      }
  }

  const storeAiDetails=(contactsDetail:any, contact:any, index:any, chats:any)=>{
    setStoreAiContactDetails({contactsDetail:contactsDetail,contact:contact,index:index,chats:chats})
    getChatSummary(contactsDetail);
  }

  const openAiModal=(e:any)=>{
     setCloseAi(true);
  }


  const menuai = (
    <>
     {(!_.isEmpty(storeAiContactDetails?.contact?.chatSummary)) &&  closeAi &&
       <div className={styles.menuais} onClick={(e: any) => e.stopPropagation()}>
      <><h3>AI Summary <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" onClick={(e)=>closeAiModal(e)}>
        <path d="M6.70693 6.00003L11.8005 0.906301C11.9959 0.710968 11.9959 0.394568 11.8005 0.199301C11.6052 0.00403433 11.2888 0.00396764 11.0935 0.199301L5.99993 5.29303L0.906326 0.199234C0.710993 0.00390103 0.394593 0.00390103 0.199326 0.199234C0.00405926 0.394568 0.00399258 0.710968 0.199326 0.906234L5.29293 5.99997L0.199326 11.0937C0.00399258 11.289 0.00399258 11.6054 0.199326 11.8007C0.296993 11.8984 0.424926 11.9472 0.552859 11.9472C0.680793 11.9472 0.808726 11.8984 0.906393 11.8007L5.99999 6.70697L11.0936 11.8007C11.1913 11.8984 11.3192 11.9472 11.4471 11.9472C11.5751 11.9472 11.703 11.8984 11.8007 11.8007C11.996 11.6054 11.996 11.289 11.8007 11.0937L6.70693 6.00003Z" fill="#757676" />
      </svg></h3>
      <div className={styles.profileai}>
        <div className={styles.profileaileft}>
        {storeAiContactDetails.contactsDetail?.team_id ?
                            <ProfileAvatarGroup key={0} contactDetail={storeAiContactDetails.contactsDetail} profileSize={38} randomColor={[1]}></ProfileAvatarGroup>
                       :
                       <URAvatarGroup className={` ashavatorcnl lefts size28 colorBG${random_color[0]}`}
                       profileInfo={<>
                    
                         {
                           storeAiContactDetails?.contactsDetail?.profile_image_thumbnail ?
                             <img src={storeAiContactDetails?.contactsDetail?.profile_image_thumbnail} alt="" /> :
                             storeAiContactDetails?.contactsDetail?.profile_url ?
                               <img src={storeAiContactDetails?.contactsDetail?.profile_url} alt="" />
                               : <span>{storeAiContactDetails?.contactsDetail?.caller_id?.charAt(0)?.toUpperCase()}</span>}

                         {/* <URStatusDot className={userStatusColor(link.fromDetails?.user_status, 'small')} /> */}

                        
                       </>}
                     />}
        </div>
        <div className={styles.profileairight}>{storeAiContactDetails?.contactsDetail?.team_id ? storeAiContactDetails?.contactsDetail?.team_name : storeAiContactDetails?.contactsDetail?.caller_id}</div>
      </div>
      <p>{`${storeAiContactDetails?.contact?.chatSummary}`}</p>
      <div className={styles.profileaibottom}>
        <button onClick={()=>aiOptions("openchat")}>Open chat</button>
        <button onClick={()=>aiOptions("markread")}>Mark as read</button>
      </div></>
    </div>}
    </>
  );


  try {
    return (
      <>




        {
          ((!recentLoading || !allContacs?.allContacsLoading || allContacs?.allContacs?.length === 0)) ? ([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map((item: any, index: any) => (
            <URChatLeftSkeleton width={100} key={index} />
          ))) : null

        }
        {allContacs?.allContacsLoading && allContacs?.allContacs?.length > 0 && recentLoading && searchContactList?.length === 0 &&

          <NoContent image={noResult}
            title={''}
            description={'Oh,no results found'} />}
        {allContacs?.allContacsLoading && allContacs?.allContacs?.length > 0 && recentLoading && searchContactList?.length > 0
          && Array.isArray(searchContactList) && searchContactList?.map((contact: any, index: any) => {
            try {
              // let finalString = ''; delContact !==undefined?delContact:
              let toContact = parseInt(contact.to);
              let delContact = deleteContact[toContact];
              let contactsDetail = contact.type === 1 ? workContact[toContact] : teamContact["con" + contact.chatId];
              if ((contact?.lastmessage === "") ||
                (_.isUndefined(contact?.lastmessage?.message) === false &&
                  (_.isUndefined(contact?.lastmessage?.message?.body) === false
                    || _.isEmpty(contact?.lastmessage?.message?.body)))) {

                let finalString = contact?.lastmessage?.message?.messageType === "BROADCAST" ? teamfinalString(contact?.lastmessage) : ""
                // contact?.lastmessage?.message?.messageType === "BROADCAST" ? teamfinalString(contact?.lastmessage) : 
                if (contactsDetail) {
                  const menu = (
                    <ul onClick={(e: any) => e.stopPropagation()}>
                      <Menu onClick={(key) => selectMoreOption(key, contact)}>

                        {(!contact?.settings?.isFavourite || contact?.settings?.isFavourite["s" + userdetails?.sip_login_id] === 0)
                          ? <Menu.Item key={"favourite"} >Add to Favourites</Menu.Item> : <Menu.Item key={"unfavourite"} >Remove from Favourites</Menu.Item>}
                        {(!contact?.settings?.isMuted || contact?.settings?.isMuted["s" + userdetails?.sip_login_id] === 0 || contact?.settings?.isMuted["s" + userdetails?.sip_login_id] === undefined)
                          ? <Menu.Item key={"muteChat"} >Mute Notifications</Menu.Item> : <Menu.Item key={"unMuteChat"}>Unmute Notifications</Menu.Item>}
                        {(!contact?.settings?.isPinned || contact?.settings?.isPinned["s" + userdetails?.sip_login_id] === 0)
                          ? <Menu.Item key={"pinChat"}>Pin Chat</Menu.Item> : <Menu.Item key={"unpinChat"}>Unpin Chat</Menu.Item>}
                        {(contact?.unreadCount > 0) || (contact?.settings?.markRead && contact?.settings?.markRead["s" + userdetails?.sip_login_id] === 2)
                          ? <Menu.Item key="markRead">Mark as Read</Menu.Item> : <Menu.Item key="markUnRead">Mark as UnRead</Menu.Item>}
                        {(!contact?.settings?.isArchive || contact?.settings?.isArchive["s" + userdetails?.sip_login_id] === 0)
                          ? <Menu.Item key={"isArchive"}>Archive Member</Menu.Item> : <Menu.Item key={"unarchive"}>Unarchive Chat</Menu.Item>}
                        {(!contact?.settings?.isDeleted || contact?.settings?.isDeleted["s" + userdetails?.sip_login_id] === 0) ?
                          <Menu.Item key={"deleteChat"}>Delete Chat</Menu.Item> : null}
                        {(userdetails?.ext === '200' && contact?.type === 1) ?
                          <Menu.Item key={"deactivateContact"}>Deactivate Contact</Menu.Item> : null}
                      </Menu>
                    </ul>
                  );

                  if (contact.type !== 1) {
                    contactsDetail.teammembersdetails = contact?.teammembersdetails;
                  }

                  //  console.log(toContact,'contactsDetail?.caller_id---->',contactsDetail?.caller_id);
                  let nameLength: any = contactsDetail?.caller_id ? contactsDetail?.caller_id : contactsDetail?.team_name;
                  let drafconst = chatWindow?.chatWindowDetails?.team_id ? chatWindow?.chatWindowDetails?.team_id === contactsDetail?.team_id : chatWindow?.chatWindowDetails?.sip_login_id === contactsDetail?.sip_login_id
                  let draftList: any = _.filter(pinnedList.draftContacts, function (obj: any) { return contactsDetail?.team_id ? obj?.contactDetail?.team_id === contactsDetail?.team_id : obj?.contactDetail?.sip_login_id === contactsDetail?.sip_login_id });
                  // let strippedString = contact?.lastmsgText.replace(/(<([^>]+)>)/gi, " ");
                  let strippedString = !drafconst && draftList?.length > 0 ? draftList[0].msgText.replace(/(<([^>]+)>)/gi, " ") : strickerFormat.indexOf(contact?.lastmessage.message?.body?.fileType) !== -1 ? "" : contact?.lastmsgText.replace(/<style.*?<\/style>/g, '').replace(/<(?!\/?b>|\/?i>|\/?strike>)[^>]+>/g, ' ');

                  let strippedRes = <span className={styles.textM} dangerouslySetInnerHTML={{ __html: (strippedString) }}></span>
                  const typingTeam: any = contactsDetail?.team_id && typingList["con" + contactsDetail?.team_id?.toString()]
                    && typingList["con" + contactsDetail?.team_id?.toString()]?.participants
                    && Object.values(typingList["con" + contactsDetail?.team_id?.toString()]?.participants);
                  const participantsTotal = Array.isArray(typingTeam) && typingTeam.length === 1 ?
                    Object.values(typingList["con" + contactsDetail?.team_id?.toString()]?.participants) :
                    Array.isArray(typingTeam) && typingTeam.length > 1
                      ? Object.values(typingList["con" + contactsDetail?.team_id?.toString()]?.participants).map((value: any) => value.caller_id) : [];
                  //  console.log("participantsTotal --->",participantsTotal);
                  return (<div className={`${styles.profilelists} ${chats ? chats : ""}Recent
                ${(!chatWindow.chatWindowDetails?.isMySpace &&
                      (((chatWindow?.chatWindowDetails?.sip_login_id && chatWindow?.chatWindowDetails?.sip_login_id === contactsDetail?.sip_login_id) ||
                        (chatWindow?.chatWindowDetails?.team_id && chatWindow?.chatWindowDetails?.team_id === contactsDetail?.team_id))))
                      ? styles.active :
                      (chatWindow?.chatWindowDetails?.sip_login_id && (chatWindow?.chatWindowDetails?.sip_login_id === contactsDetail?.sip_login_id)) ||
                        (chatWindow?.chatWindowDetails?.team_id && (chatWindow?.chatWindowDetails?.team_id === contactsDetail?.team_id))
                        ?
                        styles.activeHover : ""}
            ${contact?.unreadCount > 0 ? styles.unreads : ""}`} onClick={() => OpenChatWindow(contactsDetail, contact, index, chats ? chats + "Recent" : "")} key={index}>
                    <div className={styles.profileDetailspop}>
                      {!contactsDetail.team_id ?
                        <Popover placement="bottomRight" /*content={content}*/ trigger="click" overlayClassName="contactDetailspp">
                          <span title="View profile">
                            <ProfileAvatarGroup contactDetail={contactsDetail} profileSize={38} randomColor={random_color[index]}></ProfileAvatarGroup>
                          </span>
                        </Popover> : <ProfileAvatarGroup contactDetail={contactsDetail} profileSize={38} randomColor={random_color[index]}></ProfileAvatarGroup>}
                      {typingList[contactsDetail?.sip_login_id?.toString()]?.msgType === 1 ||
                        typingList["con" + contactsDetail?.team_id?.toString()]?.msgType === 2 ? (
                        <div className={styles.typingSts}>
                          {/* <Lottie className="typingSts" animationData={groovyWalkAnimation} /> */}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className={styles.middle} tabIndex={index} >
                      {/* {nameLength?.length > 15 && <Tooltip overlayClassName="tooltiplftsizesm" mouseEnterDelay={1.0} placement="top" title={contactsDetail?.caller_id ? contactsDetail?.caller_id : contactsDetail?.team_name}>
                        <h4>
                          <HighlightInner content={contactsDetail?.caller_id ? contactsDetail?.caller_id : contactsDetail?.team_name} searchedData={searchText}></HighlightInner>
                        </h4>
                      </Tooltip>} */}

                      <h4>
                        <HighlightInner content={contactsDetail?.caller_id ? contactsDetail?.caller_id : contactsDetail?.team_name} searchedData={searchText}></HighlightInner>
                      </h4>


                      {contactsDetail?.is_blocked !== 1 && <>
                        {typingList && typingList[contactsDetail?.sip_login_id?.toString()] && typingList[contactsDetail?.sip_login_id?.toString()]?.msgType === 1 &&
                          typingList[contactsDetail?.sip_login_id?.toString()]?.sip_login_id !== contactsDetail?.sip_login_id?.toString() &&
                          typingList?.[contact?.to]?.sip_login_id === parseInt(contact?.to)
                          ? <p> typing....</p> :
                          typingList["con" + contactsDetail?.team_id?.toString()]
                            &&
                            typingList["con" + contactsDetail?.team_id?.toString()]?.participants && contactsDetail?.team_id && participantsTotal.length > 0
                            ?
                            <p>{`${Array.isArray(participantsTotal) && participantsTotal.length === 1 ? participantsTotal[0]?.caller_id :
                              participantsTotal.join(',')}`} typing...</p>
                            : !drafconst && draftList?.length > 0 ? <p title="View Chat"><span className={styles.textDraft}>Draft: </span>  {strippedRes}</p> :
                              <p title="View Chat">{
                                contact?.lastmessage?.message?.messageType !== "BROADCAST" && contact?.lastmessage?.from?.toString() === userdetails?.sip_login_id.toString() && contact?.lastmessage?.message?.isDelete?.all !== 1 &&
                                <span className={contact && contact?.lastmessage && contact?.lastmsgText !== ""
                                  && contact?.lastmessage?.readStatus === 1 && contact?.lastmsgText !== undefined ?
                                  "msgRead icon_doubleclick" : contact?.lastmessage?.deliveryStatus === 8 && contact?.lastmsgText !== "" && contact?.lastmsgText !== undefined ? "icon_doubleclick" : contact?.lastmsgText !== "" && contact?.lastmsgText !== undefined ? "sentMsg" : ""}></span>}

                                {contact?.lastmessage && !contact?.lastmessage?.message?.isDelete?.all && (contact?.lastmessage.message?.messageType === "IMAGE" ||
                                  contact?.lastmessage?.message?.messageType === "FILE") && <span className={videoFormat.indexOf(contact?.lastmessage.message?.body?.fileType) !== -1 ? "icon_meetfill" : mp3Formats.indexOf(contact?.lastmessage.message?.body?.fileType) !== -1 ? "icon_microphone" :
                                    strickerFormat.indexOf(contact?.lastmessage.message?.body?.fileType) !== -1 ? `stickerIconchat` : "icon_image"} ></span>}
                                {contact?.lastmessage && contact?.lastmessage?.message?.messageType === "TASK" && <><span className="icon_task"></span></>}
                                {contact?.lastmessage && contact?.lastmessage?.message?.messageType === "EVENTS" && <><span className="icon_datepick"></span></>}
                                {contact?.lastmessage && contact?.lastmessage?.message?.messageType === "GEO" && "\u{26f3} "}
                                {strickerFormat.indexOf(contact?.lastmessage.message?.body?.fileType) !== -1 && "STICKER"}
                                {contact?.lastmessage && contact?.lastmessage?.message?.messageType === "AT_MENTION" && contact?.lastmessage?.message?.body}
                                {/* {contact?.lastmessage && contact?.lastmessage?.message?.isDelete?.all === 1 && <> <span className="icon_blockdelete"> </span></>}  */}
                                {contact?.lastmessage && contact?.lastmessage?.message?.messageType === "NOTES" && <><span className="icon_note"></span></>}
                                {contact?.lastmessage && contact?.lastmessage?.message?.messageType === "BROADCAST" ? finalString : ""}
                                {contact?.lastmessage?.message?.messageType === "TEXT" && contact?.lastmessage && contact?.lastmessage?.message?.isLink && <><span className="icon_link"></span></>}
                                {contact?.lastmessage && contact?.lastmessage?.message?.messageType === "TASK" ? "Created a Task" :
                                  contact?.lastmessage?.message?.messageType === "EVENTS" ? "Created a Event" : contact?.lastmessage?.message?.messageType === "NOTE" ? "Created a Note" :
                                    contact?.lastmessage?.message?.isDelete?.all === 1 ? "Deleted this message" : contact?.lastmessage?.message?.messageType !== "AT_MENTION" && contact?.lastmessage?.message?.messageType !== "BROADCAST" && strippedRes}

                              </p>}</>
                      }
                    </div>


                    <div className={styles.rights}>
                      {delContact !== undefined ? <label className={styles.deletebtn}>Deleted</label> :

                        <div className="timecontainer">
                          <span>{getRecentDateFormat(contact?.lastmessage?.timestamp ? contact?.lastmessage?.timestamp :
                            contact?.timestamp)}</span>
                          <div className={styles.rightbottomarea}>
                            {contact?.unreadCount > 0 && <><div className={styles.unReadMsgCount}> {contact?.unreadCount}</div>
                            <Dropdown className={(isButtonDisabled === false) ? 'disabledIcon':''} overlay={menuai} trigger={['click']} onClick={(e: any) => e.stopPropagation()}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" onMouseEnter={()=>storeAiDetails(contactsDetail, contact, index, chats ? chats + "Recent" : "")} onClick={openAiModal}>
                                <path d="M11.6964 1.64498L10.8376 0.79678C10.6427 0.604313 10.3888 0.50818 10.1349 0.50818C9.87689 0.508247 9.61903 0.607447 9.42336 0.805513L1.02563 9.30805C0.637492 9.70098 0.641492 10.3341 1.03443 10.7222L1.89329 11.5705C2.08816 11.763 2.34209 11.8591 2.59596 11.8591C2.85396 11.8591 3.11183 11.7598 3.30749 11.5618L11.7052 3.05925C12.0933 2.66631 12.0894 2.03305 11.6964 1.64498ZM2.59603 10.859L1.73716 10.0108L7.62916 4.04465L8.48989 4.89158L2.59603 10.859ZM9.19256 4.18011L8.33183 3.33311L10.134 1.50831L10.1349 1.50825L10.9938 2.35645L9.19256 4.18011Z" fill="#575CFF" />
                                <path d="M11.8963 8.85165C11.9608 8.89491 11.9931 8.94831 11.9931 9.01298C11.9931 9.07751 11.9608 9.13151 11.8963 9.17431L10.6054 9.69065L10.089 10.9816C10.0456 11.0461 9.99223 11.0784 9.92756 11.0784C9.86303 11.0784 9.80916 11.046 9.76623 10.9816L9.24989 9.69065L7.95896 9.17431C7.89443 9.13151 7.86216 9.07751 7.86216 9.01298C7.86216 8.94831 7.89449 8.89491 7.95896 8.85165L9.24989 8.33518L9.76623 7.04425C9.80916 6.97971 9.86303 6.94758 9.92756 6.94758C9.99223 6.94758 10.0456 6.97978 10.089 7.04425L10.6054 8.33518L11.8963 8.85165Z" fill="#575CFF" />
                                <path d="M4.04036 3.11425C4.10489 3.15751 4.13716 3.21091 4.13716 3.27558C4.13716 3.34011 4.10483 3.39411 4.04036 3.43691L2.74943 3.95325L2.23309 5.24418C2.18969 5.30871 2.13629 5.34098 2.07163 5.34098C2.00709 5.34098 1.95323 5.30865 1.91029 5.24418L1.39396 3.95325L0.103026 3.43691C0.0384923 3.39411 0.00622559 3.34011 0.00622559 3.27558C0.00622559 3.21091 0.0385589 3.15751 0.103026 3.11425L1.39396 2.59778L1.91029 1.30685C1.95323 1.24231 2.00709 1.21018 2.07163 1.21018C2.13629 1.21018 2.18969 1.24238 2.23309 1.30685L2.74943 2.59778L4.04036 3.11425Z" fill="#575CFF" />
                                <path d="M7.22996 1.39658C7.27249 1.42511 7.29383 1.46031 7.29383 1.50298C7.29383 1.54551 7.27249 1.58111 7.22996 1.60938L6.37876 1.94985L6.03829 2.80105C6.00969 2.84358 5.97443 2.86491 5.93183 2.86491C5.88929 2.86491 5.85376 2.84358 5.82543 2.80105L5.48496 1.94985L4.63376 1.60938C4.59123 1.58118 4.56989 1.54551 4.56989 1.50298C4.56989 1.46038 4.59123 1.42511 4.63376 1.39658L5.48496 1.05605L5.82543 0.204847C5.85376 0.162313 5.88929 0.141113 5.93183 0.141113C5.97443 0.141113 6.00969 0.162313 6.03829 0.204847L6.37876 1.05605L7.22996 1.39658Z" fill="#575CFF" />
                              </svg>
                            </Dropdown>
                            
                            </>
                            
                            }

                            {contact?.unreadCount === 0 && contact?.settings?.markRead && contact?.settings?.markRead["s" + userdetails?.sip_login_id] === 2 && <span className={styles.unreadDot}></span>}
                            {(!contact?.settings?.isMuted || contact?.settings?.isMuted["s" + userdetails?.sip_login_id] === 0 || contact?.settings?.isMuted["s" + userdetails?.sip_login_id] === undefined) ? "" : <div className={styles.muteNtf}><span className="icon_fillnotification"></span></div>}
                            {contact?.settings?.isPinned && contact?.settings?.isPinned["s" + userdetails?.sip_login_id] === 1 &&
                              <div className={styles.muteNtf}><span className="icon_pin"></span></div>}
                            {contactsDetail?.is_blocked !== 1 && <Dropdown overlay={menu} placement="bottomRight" trigger={['click']} onClick={(e: any) => e.stopPropagation()}>
                              <span className={` leftmenudrops menudroppclst ${"icon_down-arrow"} ${styles.menudrop}`}
                                onClick={e => e.preventDefault()}>
                              </span>
                            </Dropdown>}

                          </div>
                        </div>}
                    </div>

                  </div>)
                } else {
                  return null;
                }
              }
            }
            catch (e) {
              console.error("Error in Recent Chat List", e);
              return <>Something went wrong</>
            }
          }

          )}

        <Modal visible={ArchiveModal.isArchive}
          className={`${styles.clearchatmodal} ${"modaloverwrite"}`}>
          <span onClick={handleArchiveCancel} className={`icon_close ${styles.cursorTop}`} />
          <h2>Archive Chat</h2>
          <p>When you archive a chat, you will no longer receive notification from this conversation. The chat will also be removed from your recent chat list. <span>Do you wish to proceed?</span></p>

          <div className={styles.footersection}>
            <URButton className="urButton buttonWhite buttonMd mr8" onClick={handleArchiveCancel} name="Cancel"></URButton>
            <URButton className="urButton buttonRed buttonMd" onClick={archiveAction} name="Yes, Archive"></URButton>
          </div>
        </Modal>
        {ArchiveModal.isDeactivate && <Modal visible={ArchiveModal.isDeactivate}
          className={`${styles.clearchatmodal} ${"modaloverwrite"}`}>
          <span onClick={handleArchiveCancel} className={`icon_close ${styles.cursorTop}`} />
          <h2>Deactivate Contact</h2>
          <p>{ArchiveModal?.deactivateData?.caller_id} will not be able to contact you. Are you sure you want to deactivate this contact?</p>

          <div className={styles.footersection}>
            <URButton className="urButton buttonWhite buttonMd mr8" onClick={handleDeactiveCancel} name="Cancel"></URButton>
            <URButton className="urButton buttonRed buttonMd" onClick={deactivateAction} name="Deactivate"></URButton>
          </div>
        </Modal>}

        {ArchiveModal.isDelete && <Modal visible={ArchiveModal.isDelete}
          className={`${styles.clearchatmodal} ${"modaloverwrite"}`}>
          <span onClick={handleCancel} className={`icon_close ${styles.cursorTop}`} />
          <h2>Delete this Chat?</h2>
          <p>You will not be able to retrieve this conversation history with {ArchiveModal?.deleteData?.team_id ?
            ArchiveModal?.deleteData?.team_name :
            ArchiveModal?.deleteData?.caller_id} once you delete the chat</p>
          <div className={styles.footersection}>
            <URButton className="urButton buttonWhite buttonMd mr8" onClick={handleCancel} name="Cancel"></URButton>
            <URButton className="urButton buttonRed buttonMd" onClick={deleteAction} name="Delete Chat"></URButton>
          </div>
        </Modal>}
        {ArchiveModal?.isMuteModel && <Modal visible={ArchiveModal?.isMuteModel} title={`Mute ${ArchiveModal?.deleteData?.caller_id ? ArchiveModal?.deleteData?.caller_id : ArchiveModal?.deleteData?.team_name} Notifiction for...`}
          centered
          onOk={handleOk}
          onCancel={handleCancelMute}
          cancelText="Cancel"
          okText="Mute Notification"
          cancelButtonProps={{ className: 'urButton buttonWhite' }}
          okButtonProps={{ className: 'urButton buttonBlue' }} className="customPopup ">
          <div className="muteNtf">
            <Form.Item >
              <Radio.Group onChange={(e) => radioChecked(e)} value={ArchiveModal.radioMute}>
                <Radio value={'Until 8:00 AM'}><span className="radiotxt">
                  Until 8:00 AM</span></Radio>
                <Radio value={'1 Hr'}><span className="radiotxt">
                  1 Hr</span></Radio>
                <Radio value={'12 Hr'}><span className="radiotxt">
                  12 Hr</span></Radio>
                <Radio value={'1 Week'}><span className="radiotxt">
                  1 Week</span></Radio>
                <Radio value={'Always'}><span className="radiotxt">
                  Always</span></Radio>
              </Radio.Group>
            </Form.Item>

          </div>
        </Modal>}

      </>
    );
  }
  catch (e) {
    return <>Something Went Wrong</>
  }
};

export default React.memo(ContactLists)



